import BankDetails from './BankDetails'
export default BankDetails
